import { Flex, Heading, Image } from "@chakra-ui/react";

const Logo = ({ image, size, color }) => {
  return (
    <Flex align="center" gap={5}>
      <Image
        src={image}
        alt="logo"
        height={size}
        style={{
          border: "2px solid #63aab5",
          borderRadius: "5px",
        }}
      />
      <Heading
        fontFamily="Shantell Sans"
        color={color}
        fontSize={{ base: "30px", md: "40px" }}
      >
        Learn Setback
      </Heading>
    </Flex>
  );
};
export default Logo;
